import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

// Base
import Button from '../../../../../base/button';
import Modal from '../../../../../base/modal';
import Wysiwyg from '../../../../../base/wysiwyg';

export default class Popup extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    message: PropTypes.string.isRequired,
    onSetMessage: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  render() {
    const { isOpen, onCancel, message, onSetMessage, onSkip, onConfirm } = this.props;

    return (
      <Modal {...{
        isOpen,
        onCancel,
        onClose: onCancel,
        className: 'enterprise pop',
        showX: false,
      }}>
        <div className='absolute top-24 right-24'>
          <Button {...{
            size: 'custom',
            onClick: onCancel,
          }}>
            <X {...{ size: 24 }} />
          </Button>
        </div>
        <div className='padding-left-25 margin-top-24 heading-section margin-bottom-30'>
          <div className='xlg-font line-height-26 heading margin-bottom-15'>How can we help you</div>
          <div className='sm-font sub-heading line-height-24 margin-bottom-24'>Please let us know what kind of information you're looking for so we can better tailor our support to meet your needs.</div>
        </div>
        <div className='margin-left-25 inline-block'>
          <Wysiwyg {...{
            onChange: onSetMessage,
            value: message,
            className: 'min-height-130 height-130 overflow-auto',
          }} />
        </div>
        <div className='absolute bottom-24 right-24 flex'>
          <Button {...{
            text: 'Skip',
            onClick: onSkip,
            size: 'custom',
            className: 'cancel',
          }} />
          <Button {...{
            text: 'Confirm',
            block: true,
            className: 'submit',
            onClick: onConfirm,
          }} />
        </div>
      </Modal>
    )
  }
}